<template>
  <div class="resetPassword">
    <el-main>
      <el-row class="nofull">
        <el-main>
          <el-row style="width: 500px; margin: 30px auto">
            <img class="logo" src="../assets/logo_new.png" />
            <div class="site_name">{{ siteName }}</div>
          </el-row>
          <el-row style="width: 500px; margin: 0 auto; padding-bottom: 100px">
            <p style="margin-bottom: 20px">重置密码</p>
            <el-steps
              :active="active"
              finish-status="success"
              style="margin-bottom: 20px"
            >
              <el-step title="1 获取认证码"></el-step>
              <el-step title="2 设置新密码"></el-step>
              <el-step title="3 完成"></el-step>
            </el-steps>
            <!-- 1 获取认证码步骤 -->
            <el-row v-if="this.active === 1">
              <el-form :model="setNewPWForm1" :rules="rule" ref="setNewPWForm1">
                <el-form-item class="setNewPWFormItem" prop="reg_email">
                  <el-input
                    placeholder="请输入您注册使用的邮箱或手机"
                    v-model="setNewPWForm1.reg_email"
                  >
                    <template slot="prepend">邮箱或手机<el-tooltip content="国际/港澳台手机号需要以国家(或地区)码开头，如香港手机号以+852开头" placement="top-start" effect="light"><i class="el-icon-question"></i></el-tooltip></template>
                  </el-input>
                </el-form-item>
                <el-form-item
                  class="inlineFlex longforgetPWD"
                  style="width: 100%"
                  prop="captcha_code"
                >
                  <el-input
                    placeholder="输入验证码"
                    v-model="setNewPWForm1.captcha_code"
                    autocomplete="off"
                    autocapitalize="off"
                    spellcheck="false"
                  >
                    <template slot="prepend"
                      >验<span style="margin-left: 0.5em" />证<span
                        style="margin-left: 0.5em" />码<i class="el-icon-lock"
                    /></template>
                  </el-input>
                  <div class="captcha_code" v-if="showCaptchaBtn === 0">
                    <img :src="captcha_url" ref="code" @click="changeCode" />
                    <div style="font-size: 12px; line-height: 20px">
                      看不清？点图刷新
                    </div>
                  </div>
                  <el-button
                    v-if="showCaptchaBtn === 1"
                    style="margin-left: 10px; padding: 12px"
                    @click="toGetCaptchaCode"
                    >获取验证码</el-button
                  >
                </el-form-item>
                <el-form-item
                  class="inlineFlex longforgetPWD"
                  style="width: 100%"
                  prop="verify_code"
                >
                  <el-input
                    placeholder="输入认证码"
                    v-model="setNewPWForm1.verify_code"
                    autocomplete="off"
                    autocapitalize="off"
                    spellcheck="false"
                  >
                    <template slot="prepend"
                      >认<span style="margin-left: 0.5em" />证<span
                        style="margin-left: 0.5em" />码<i class="el-icon-lock"
                    /></template>
                  </el-input>
                  <el-button
                    :disabled="sendMsgDisabled"
                    style="height: 40px; margin-left: 10px; padding: 12px"
                    @click="handleResetPassword"
                  >
                    <span v-if="!sendMsgDisabled">获取认证码</span>
                    <span v-if="sendMsgDisabled">{{
                      codeTime + '秒后获取'
                    }}</span>
                  </el-button>
                </el-form-item>
                <el-alert
                  :style="{ display: topTextMessageVisible }"
                  :title="topTextMessage"
                  type="success"
                  @close="topTextMessageClose"
                >
                </el-alert>
                <el-alert
                  :style="{ display: serNewPWMessageVisible }"
                  :title="serNewPWMessage"
                  type="error"
                  @close="serNewPWMessageClose"
                >
                </el-alert>
                <el-button
                  type="primary"
                  style="width: 100%; margin-top: 20px"
                  @click="resetPWDNext"
                  :loading="loading"
                  >下一步</el-button
                >
              </el-form>
            </el-row>
            <!-- 2 填写新密码步骤 -->
            <el-row v-else-if="this.active === 2">
              <el-form
                :model="setNewPWForm2"
                :rules="rules2"
                ref="setNewPWForm2"
              >
                <el-form-item class="setNewPWFormItem" prop="newPwd">
                  <el-input
                    placeholder="输入新密码"
                    v-model="setNewPWForm2.newPwd"
                    type="password"
                  >
                    <template slot="prepend"
                      >新<span style="margin-left: 0.5em" />密<span
                        style="margin-left: 0.5em" />码<i class="el-icon-lock"
                    /></template>
                  </el-input>
                </el-form-item>
                <el-form-item
                  class="setNewPWFormItem"
                  prop="rePwd"
                  style="margin-bottom: 20px"
                >
                  <el-input
                    placeholder="确认新密码"
                    v-model="setNewPWForm2.rePwd"
                    type="password"
                  >
                    <template slot="prepend"
                      >确认密码<i class="el-icon-lock"
                    /></template>
                  </el-input>
                </el-form-item>
              </el-form>
              <el-alert
                :style="{ display: serNewPWMessageVisible }"
                :title="serNewPWMessage"
                type="error"
                @close="serNewPWMessageClose"
              >
              </el-alert>
              <el-button
                :loading="loading"
                type="primary"
                style="width: 100%"
                @click="handleSetNewPassword"
                >{{ loading ? '正在设置新密码 ...' : '确 定' }}</el-button
              >
            </el-row>
            <!-- 3 完成步骤 -->
            <el-row v-else-if="this.active === 3">
              <i class="el-icon-success big"></i>
              <p style="margin-bottom: 20px">重置密码成功</p>
              <p style="text-align: left; font-size: 15px"></p>
              <el-button
                type="primary"
                style="width: 100%"
                @click="handleToLogin"
                >前往登录</el-button
              >
            </el-row>
            <!-- 以上步骤为内容 -->
          </el-row>
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import {
  postSetNewPassword,
  postSetNewPasswordPhone,
} from '@/apis/setNewPassword.js';
import {
  passwordReset,
  passwordResetPhone,
  verifyEmailCode,
  verifyPhoneCode,
} from '@/apis/passwordModify';
import { getCaptcha } from '@/apis/captcha';
export default {
  name: 'forgetPassword',
  props: {
    siteName: String,
  },
  mounted() {
    this.toGetCaptchaCode();
    this.$emit('activeIndex', '');
    this.$emit('pageClass', 'userCenter');
  },
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.setNewPWForm2.newPwd !== '') {
          this.$refs.setNewPWForm2.validateField('rePwd');
        }
        callback();
      }
    };
    let validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.setNewPWForm2.newPwd) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };

    return {
      active: 1,
      rules: 0,
      rules1: {
        reg_email: [
          { required: true, message: '请输入邮箱或手机', trigger: 'blur' },
          // {
          //   type: 'email',
          //   message: '请输入正确的邮箱地址',
          //   trigger: ['blur', 'change'],
          // },
        ],
        captcha_code: [
          {
            required: true,
            message: '请输入右侧图片中的验证码',
            trigger: 'blur',
          },
          { min: 4, message: '认证码为4位数字或英文字符', trigger: 'blur' },
          { max: 4, message: '认证码为4位数字或英文字符', trigger: 'blur' },
        ],
      },
      rules1_1: {
        reg_email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          // {
          //   type: 'email',
          //   message: '请输入正确的邮箱地址',
          //   trigger: ['blur', 'change'],
          // },
        ],
        captcha_code: [
          {
            required: true,
            message: '请输入右侧图片中的验证码',
            trigger: 'blur',
          },
          { min: 4, message: '认证码为4位数字或英文字符', trigger: 'blur' },
          { max: 4, message: '认证码为4位数字或英文字符', trigger: 'blur' },
        ],
        verify_code: [
          {
            required: true,
            message: '请输入您邮箱收到的认证码',
            trigger: 'blur',
          },
          { min: 4, message: '认证码为4位数字或英文字符', trigger: 'blur' },
          { max: 4, message: '认证码为4位数字或英文字符', trigger: 'blur' },
        ],
      },
      rules2: {
        newPwd: [
          {
            validator: validatePass,
            required: true,
            message: '请输入新密码',
            trigger: 'blur',
          },
          { min: 6, message: '密码至少 6 个字符', trigger: 'blur' },
          { max: 20, message: '密码最多 20 个字符', trigger: 'blur' },
        ],
        rePwd: [{ validator: validatePass2, trigger: 'blur' }],
      },
      codeTime: 59, // 发送验证码倒计时
      sendMsgDisabled: false, // 是否显示获取验证码按钮
      serNewPWMessageVisible: 'none',
      topTextMessageVisible: 'none',
      serNewPWMessage: '',
      topTextMessage: '',
      user_name: '',

      setNewPWForm1: {
        reg_email: '',
        verify_code: '',
        captcha_code: '',
      },
      setNewPWForm2: {
        newPwd: '',
        rePwd: '',
        captcha_code: '',
      },

      loading: false,

      captcha_url: '',
      showCaptchaBtn: 1,
      captcha_id: '',
    };
  },
  methods: {
    // 生成验证码随机字符
    randomCaptchaKey() {
      function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
      }

      this.captcha_id =
        S4() +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        '-' +
        S4() +
        S4() +
        S4();
    },
    // 得到验证码图片
    changeCode() {
      this.randomCaptchaKey();
      getCaptcha({ captcha_id: this.captcha_id })
        .then((res) => {
          if (res.status === 200) {
            let rr = window.URL.createObjectURL(res.data);
            this.captcha_url = rr;
          } else {
            this.$message.error('未请求成功');
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toGetCaptchaCode() {
      this.changeCode();
      this.showCaptchaBtn = 0;
    },
    // 获取认证码
    handleResetPassword() {
      this.rules = 0;
      this.$refs['setNewPWForm1'].validate((valid) => {
        if (valid) {
          this.serNewPWMessageVisible = 'none';
          (this.setNewPWForm1.reg_email.includes('@')
            ? passwordReset({
                reg_email: this.setNewPWForm1.reg_email,
                captcha_id: this.captcha_id,
                captcha_code: this.setNewPWForm1.captcha_code,
              })
            : passwordResetPhone({
                phone: this.setNewPWForm1.reg_email,
                captcha_id: this.captcha_id,
                captcha_code: this.setNewPWForm1.captcha_code,
              })
          )
            .then((res) => {
              if (res.status === 200) {
                if (res.data.success === true) {
                  console.log(res.data.data);
                  this.topTextMessage = '认证码已发送。';
                  this.topTextMessageVisible = 'block';
                  this.sendMsgDisabled = true;
                  let codeInterval = window.setInterval(() => {
                    this.codeTime--;
                    if (this.codeTime < 0) {
                      window.clearInterval(codeInterval);
                      this.codeTime = 59;
                      this.sendMsgDisabled = false;
                    }
                  }, 1000);
                } else {
                  this.serNewPWMessage = res.data.message;
                  this.serNewPWMessageVisible = 'block';
                }
              } else {
                this.$message.error('认证码获取失败，请联系管理员');
                console.log('错误');
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },
    // 输入认证码之后的下一步按钮
    resetPWDNext() {
      this.rules = 1;
      this.$refs['setNewPWForm1'].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.topTextMessageVisible = 'none';
          const res = await (this.setNewPWForm1.reg_email.includes('@')
            ? verifyEmailCode({
                reg_email: this.setNewPWForm1.reg_email,
                captcha_id: this.captcha_id,
                captcha_code: this.setNewPWForm1.captcha_code,
                verify_code: this.setNewPWForm1.verify_code,
              })
            : verifyPhoneCode({
                phone: this.setNewPWForm1.reg_email,
                captcha_id: this.captcha_id,
                captcha_code: this.setNewPWForm1.captcha_code,
                phone_verify_code: this.setNewPWForm1.verify_code,
              }));
          if (res.status === 200) {
            if (res.data.success === true) {
              this.active = 2;
              this.serNewPWMessageVisible = 'none';
            } else {
              this.serNewPWMessage = res.data.message;
              this.serNewPWMessageVisible = 'block';
              this.loading = false;
            }
          } else {
            this.$message.error('未请求成功');
            this.loading = false;
            console.log('请求错误');
          }
          this.loading = false;
        }
      });
    },
    // 设置新密码
    handleSetNewPassword() {
      this.$refs['setNewPWForm2'].validate((valid) => {
        if (valid) {
          (this.setNewPWForm1.reg_email.includes('@')
            ? postSetNewPassword({
                reg_email: this.setNewPWForm1.reg_email,
                new_login_pwd: this.setNewPWForm2.newPwd,
                captcha_id: this.captcha_id,
                captcha_code: this.setNewPWForm2.captcha_code,
                verify_code: this.setNewPWForm1.verify_code,
              })
            : postSetNewPasswordPhone({
                phone: this.setNewPWForm1.reg_email,
                new_login_pwd: this.setNewPWForm2.newPwd,
                captcha_id: this.captcha_id,
                captcha_code: this.setNewPWForm2.captcha_code,
                phone_verify_code: this.setNewPWForm1.verify_code,
              })
          )
            .then((res) => {
              this.loading = true;
              console.log(res.data);
              this.timer = setTimeout(() => {
                // 动画关闭需要一定的时间
                if (res.status === 200) {
                  if (res.data.success === true) {
                    setTimeout(() => {
                      this.loading = false;
                      this.active = 3;
                      this.$message({
                        showClose: true,
                        type: 'success',
                        message: '成功',
                      });
                    }, 800);
                  } else {
                    this.serNewPWMessage = res.data.message;
                    this.serNewPWMessageVisible = 'block';
                    this.loading = false;
                  }
                } else {
                  this.$message.error('未请求成功');
                  this.loading = false;
                  console.log('请求错误');
                }
              }, 2000);
            })
            .catch(() => {
              this.$message.error('未请求成功');
            });
        }
      });
    },
    serNewPWMessageClose() {
      this.serNewPWMessageVisible = 'none';
    },
    topTextMessageClose() {
      this.topTextMessageVisible = 'none';
    },
    registerMessageClose() {
      this.serNewPWMessage = 'none';
    },

    // 接通后删除
    handleToLogin() {
      this.$router.replace({ path: '/' });
      this.$store.commit('blOpenLoginBox', true);
    },
  },
  computed: {
    rule() {
      if (this.rules === 1) {
        return this.rules1_1;
      } else {
        return this.rules1;
      }
    },
  },
};
</script>

<style scoped>
.el-steps {
  text-align: left;
}
</style>
